<section class="rcx-table">
    <div class="row">
        <div class="col-lg-12">
            <div class="card btr">
                <div class="card-content">
                    <div class="card-body table-responsive">
                        <div class="row d-flex justify-content-between align-items-center">
                            <div class="col-lg-auto">
                                <h5 class="card-family m-0">
                                    <i class="bx bx-id-card me-1 text-primary"></i>Experience Approval
                                </h5>
                            </div>
                            <div class="col-sm-12 col-md-5 col-lg-3 me-auto">
                                <div class="input-group">
                                    <span class="input-group-text bg-primary" id="search"
                                        ngbTooltip="Search experiences by title." placement="top" container="body">
                                        <i class="bx bx-search-alt"></i>
                                    </span>
                                    <input type="text" class="form-control border-start-0" id="search"
                                        placeholder="Search..." autocomplete="off" [(ngModel)]="searchKeyword" />
                                </div>
                            </div>
                        </div>
                        <table class="table" id="table">
                            <thead id="table-thead">
                                <tr class="bg-light">
                                    <th scope="col" width="70">#</th>
                                    <th scope="col" width="200">Title</th>
                                    <th scope="col" width="200">Company</th>
                                    <th scope="col" width="150">Start Date</th>
                                    <th scope="col" width="150">End Date</th>
                                    <th scope="col" width="200" class="text-center">Document File</th>
                                    <th scope="col" width="200">Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    *ngFor="let experience of experiences | search : 'title' : searchKeyword; let i = index">
                                    <td>{{ i + 1 }}.</td>
                                    <td>{{ experience.title }}</td>
                                    <td>{{ experience.company }}</td>
                                    <td>{{ experience.startDate | date:'MMM dd, yyyy'}}</td>
                                    <td>{{ experience.endDate | date:'MMM dd, yyyy' || '-' }}</td>
                                    <td class="text-center"> <ng-container *ngIf="experience.documentUrl; else defaultAvatar">
                                        <img [src]="experience.documentUrl" alt="Document Image" width="30" height="25" (click)="upsertpopup(experience)" style="cursor: pointer;" />
                                      </ng-container>
                                      <ng-template #defaultAvatar>
                                        <img src="assets/images/no_media.png" alt="Default Avatar" width="30" height="25" />
                                      </ng-template></td>
                                      <td> <span class="badge rounded-pill bg-{{ experience.verificationStatus === 'VERIFIED' ? 'success' : 'warning' }}">
                                        {{ experience.verificationStatus }}
                                      </span></td>
                                </tr>
                                <tr class="no-data">
                                    <ng-container *ngIf="isLoading; else noDataTemplate">
                                        <td colspan="8">Fetching data, please wait...</td>
                                    </ng-container>
                                    <ng-template #noDataTemplate>
                                        <ng-container
                                            *ngIf="experiences && experiences.length < 1; else noSearchResults">
                                            <td colspan="8">No experiences were found.</td>
                                        </ng-container>
                                        <ng-template #noSearchResults>
                                            <td colspan="8"
                                                *ngIf="searchKeyword && (experiences | search : 'title' : searchKeyword).length == 0">
                                                No experiences were found for the search results.
                                            </td>
                                        </ng-template>
                                    </ng-template>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
